import React from 'react';
import { Responsive, Segment, Tab } from 'semantic-ui-react';
import axios from 'axios';
import { fetchStudyType } from '../../Lookups/util';
import SProgramStudents from './SProgramStudents';
import WithdrawalStudents from './WithdrawalStudents';
import LockedStudents from './LockedStudents';
import GradStudents from './GradStudents';
import PreviousSemesterStudents from './PreviousSemesterStudents';
import GradAgainStudents from './GradAgainStudents';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class FilterStudents extends React.Component {
    constructor(props) {
        super(props);

        let storedActiveIndex = 0;

        if (localStorage.getItem('activeIndex')) {
            storedActiveIndex = parseInt(localStorage.getItem('activeIndex'), 10);
        }

        this.state = {
            activeIndex: storedActiveIndex
        };
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        let activeRole = localStorage.getItem('activeRole');
        let activeIndex = localStorage.getItem('activeIndex');
        window.localStorage.clear();
        localStorage.setItem('activeRole', activeRole);
        localStorage.setItem('activeIndex', activeIndex);

        // let element = document.querySelectorAll('#myTab:nth-child(1)');
        // element[0].childNodes[1].classList.remove('segment');

        axios.all([fetchStudyType()])
            .then(axios.spread((typesRes) => {
                const studyTypes = typesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.displayName
                }));
                this.setState({ studyTypes });
            }))
            .catch(err => {
                console.log('Failed to fetch study types');
            });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
        localStorage.setItem('activeIndex', activeIndex);
    }

    render() {
        const panes = [
            {
                menuItem: 'Upisani studenti po semestrima',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <SProgramStudents
                        user={this.props.user}
                        studyTypes={this.state.studyTypes}

                    /></Tab.Pane>)
            },
            {
                menuItem: 'Studenti koji nisu upisani u trenutni semestar',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <PreviousSemesterStudents
                        user={this.props.user}
                        studyTypes={this.state.studyTypes}
                    /></Tab.Pane>)
            },
            {
                menuItem: 'Apsolventi',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <GradStudents /></Tab.Pane>)
            },
            {
                menuItem: 'Apsolventi ponovci',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <GradAgainStudents
                        user={this.props.user}
                        studyTypes={this.state.studyTypes}
                    /></Tab.Pane>)
            },
            {
                menuItem: 'Diplomirani / zaključani studenti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <LockedStudents /></Tab.Pane>)
            },

            {
                menuItem: 'Ispisani studenti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <WithdrawalStudents /></Tab.Pane>)
            }

        ];

        return (<div>
            <h1>Spisak studenata</h1>
            <Segment.Group raised>
                <Segment><h3>Studenti</h3></Segment>
                <Segment><Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex ? this.state.activeIndex : 0} onTabChange={this.handleTabChange} renderActiveOnly /></Segment>
            </Segment.Group>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/FilterStudents.js